import clsx from 'clsx';
import { TextActionButton } from '../text-action';
import styles from './ShowMoreToggle.module.css';
import { SHOW_LESS_LABEL, SHOW_MORE_LABEL } from './showMoreToggleLabels';

export function ShowMoreToggle({
  expanded,
  onToggle,
  className = '',
  showMoreLabel = SHOW_MORE_LABEL,
  showLessLabel = SHOW_LESS_LABEL,
  ...rest
}) {
  return (
    <TextActionButton
      type="button"
      className={clsx(styles.root, className)}
      onClick={onToggle}
      {...rest}
    >
      {expanded ? showLessLabel : showMoreLabel}
    </TextActionButton>
  );
}
